import React from "react";
import ReactDOM from "react-dom/client";
import "bootstrap/dist/css/bootstrap.min.css";
// Design tokens sit directly on top of the Bootstrap reset and ahead of every
// project stylesheet. Placing them *before* Bootstrap would let Reboot override
// the base body and heading rules the token file establishes.
import "@/styles/tokens.css";
import "@/index.css";
import App from "@/App";

// Suppress benign ResizeObserver error from Radix UI Select dropdowns
// This must run before React mounts to catch the error overlay
const origError = window.onerror;
window.onerror = function(message, source, lineno, colno, error) {
  if (message && typeof message === 'string' && message.includes('ResizeObserver loop')) {
    return true;
  }
  if (origError) return origError(message, source, lineno, colno, error);
  return false;
};
window.addEventListener('error', (e) => {
  if (e.message?.includes('ResizeObserver loop')) {
    e.stopImmediatePropagation();
    e.stopPropagation();
    e.preventDefault();
  }
});
// Patch ResizeObserver to debounce and prevent the loop error
const OriginalResizeObserver = window.ResizeObserver;
window.ResizeObserver = class PatchedResizeObserver extends OriginalResizeObserver {
  constructor(callback) {
    super((entries, observer) => {
      requestAnimationFrame(() => {
        try {
          callback(entries, observer);
        } catch (e) {
          // Intentionally swallow: ResizeObserver loop errors are harmless browser noise.
          // Logged at debug level only so production console stays clean.
          if (process.env.NODE_ENV !== 'production') console.debug('ResizeObserver callback error (suppressed):', e);
        }
      });
    });
  }
};

const container = document.getElementById("root");

// scripts/prerender.js writes real HTML for the indexable routes and stamps the
// container with the route it was rendered for. Hydrate only when the served
// path matches that stamp — nginx falls back to the prerendered homepage for
// any unmatched URL, and hydrating that against a different route would force
// React to throw the markup away anyway, with mismatch noise on the way.
const prerenderedPath = container.getAttribute("data-prerendered-path");
const canHydrate = prerenderedPath !== null && prerenderedPath === window.location.pathname;

if (canHydrate) {
  ReactDOM.hydrateRoot(container, <App />);
} else {
  ReactDOM.createRoot(container).render(<App />);
}
